<template>
  <div
    class="auth-wrapper auth-v2"
    :dir="$functions.currentLangDirection()"
  >
    <b-row
      class="auth-inner m-0"
      style="direction: ltr;"
    >
      <b-link class="brand-logo">
        <h2 class="brand-text text-primary ml-1" />
        <span class="brand-logo" />
      </b-link>

      <b-col
        lg="12"
        class="d-none d-md-flex d-lg-flex align-items-center p-0"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-0">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>

      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-4 p-lg-1 form-auth"
        :style="{ backgroundImage: `url(${backgroundUrl})` }"
        :class="{ mainbox: !isMobile}"
        style="background-size: cover;background-position: center;direction: rtl;"
      >
        <b-col
          sm="12"
          md="12"
          lg="12"
          class="box2 px-xl-2 mx-auto"
          style="margin-top: -140px;"
          :dir="$functions.currentLangDirection()"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bold mb-1"
          >
            {{ $t('ورود با رمز عبور') }}
          </b-card-title>
          <b-card-text class="mb-2">
            {{ $t('شماره موبایل و رمز عبور خود را وارد کنید') }}
          </b-card-text>

          <validation-observer ref="loginPasswordValidation">
            <div class="auth-login-form mt-2">
              <b-form-group
                :label="$t('Mobile')"
                label-for="login-mobile"
              >
                <vue-tel-input
                  v-model="mobile"
                  :only-countries="['ir', 'af', 'ae', 'iq', 'tj']"
                  default-country="IR"
                  @input="phone"
                  :placeholder="$t('Enter Mobile Number')"
                />
                <small class="text-danger">{{ mobileError }}</small>
              </b-form-group>

              <b-form-group
                label="رمز عبور"
                label-for="login-password"
              >
                <b-input-group>
                  <b-form-input
                    id="login-password"
                    v-model="password"
                    :type="passwordFieldType"
                    placeholder="رمز عبور خود را وارد کنید"
                    autocomplete="current-password"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                      style="color: #333;"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ passwordError }}</small>
              </b-form-group>

              <b-button
                type="submit"
                variant="success"
                block
                :disabled="loading"
                @click="submitLogin"
              >
                <b-spinner
                  v-if="loading"
                  variant="outline-primary"
                  small
                />
                {{ $t('ورود') }}
              </b-button>
            </div>

            <p class="text-center mt-2">
              <b-link :to="{name:'reset-password'}">
                <span style="font-weight: bolder; text-decoration: underline; color: #8fc;">رمز عبور را فراموش کرده‌ام</span>
              </b-link>
            </p>

            <div class="divider-line">
              <span>یا</span>
            </div>

            <b-button
              variant="outline-light"
              block
              :to="{name:'login'}"
            >
              ورود با رمز پیامکی
            </b-button>
          </validation-observer>
        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BCardText, BCardTitle, BImg, BButton, BSpinner,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import Vue from 'vue'
import { VueTelInput } from 'vue-tel-input'
import { functions } from '@/functions'

Vue.prototype.$functions = functions

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BCardText,
    BCardTitle,
    BImg,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    VueTelInput,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      mobile: '',
      mobileFormatted: '',
      password: '',
      mobileError: '',
      passwordError: '',
      sideImg: require('@/assets/images/pages/login-v2.jpg'),
      backgroundImg: require('@/assets/images/pages/lg.jpg'),
      loading: false,
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      return this.sideImg
    },
    backgroundUrl() {
      return this.backgroundImg
    },
  },
  setup() {
    const { appName, appLogoImage } = $themeConfig.app
    return { appName, appLogoImage }
  },
  mounted() {
    const { isRTL } = $themeConfig.layout
    const formGroup = document.getElementsByClassName('form-auth')
    if (formGroup[0]) formGroup[0].style.direction = isRTL ? 'rtl' : 'ltr'
  },
  methods: {
    phone(number, phoneObject) {
      if (phoneObject.isValid) {
        this.mobileFormatted = `0${phoneObject.number.significant}`
        this.mobileError = ''
      }
    },
    submitLogin() {
      this.mobileError = ''
      this.passwordError = ''

      if (!this.mobileFormatted || this.mobileFormatted.length !== 11) {
        this.mobileError = 'شماره موبایل نامعتبر است'
        return
      }
      if (!this.password || this.password.length < 6) {
        this.passwordError = 'رمز عبور باید حداقل 6 کاراکتر باشد'
        return
      }

      this.loading = true
      this.$store.dispatch('auth/loginPassword', {
        mobile: this.mobileFormatted,
        password: this.password,
      }).then(
        res => {
          this.loading = false
          if (res.result.numDevice === 0) {
            this.$router.push('/newdevice')
          } else {
            this.$router.push('/')
          }
        },
        error => {
          this.loading = false
          const msg = (error.response && error.response.data)
            || error.message
            || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('Error'),
              text: msg,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import '../../@core/scss/vue/pages/page-auth.scss';
.brand-logo img{ width: 70px; }
.auth-wrapper .auth-bg{ background-color: #232633; color: #fff; }
.auth-wrapper label,.auth-wrapper span,.auth-wrapper h2,.auth-wrapper .brand-text{ color: #fff !important; }
[dir=rtl] .vue-tel-input{ direction: ltr; }
.vti__dropdown-item{ color: #000; }
.vti__dropdown-item strong{ font-weight: 400; }
.vue-tel-input{ background: #fff; padding: 3px; }
.auth-wrapper label, .auth-wrapper span, .auth-wrapper h2, .auth-wrapper .brand-text{ color: #eee !important; }
.mainbox{
  background: #344935d6 !important;
  position: absolute;top: 10%;margin-left: auto;margin-right: auto;left: 0;right: 0;width: 400px;height: 500px;border-radius: 2%;
}
.mainbox .box2{ margin-top: -40px !important; }
.divider-line {
  display: flex; align-items: center; margin: 15px 0;
  &::before, &::after { content: ''; flex: 1; border-top: 1px solid #666; }
  span { padding: 0 12px; font-size: 12px; color: #aaa; }
}
</style>
